module.exports = __webpack_public_path__ + "img/teamImg14.59bba9cb.jpg";